import React from "react";
import { Medal, Crown } from "lucide-react";

const MEDALS = {
  1: { label: "ORO", ring: "border-[#F5C542]", text: "text-[#F5C542]", bg: "from-[#F5C542]/25", h: "h-40 sm:h-48", glow: "shadow-[0_0_40px_-8px_rgba(245,197,66,0.55)]" },
  2: { label: "ARGENTO", ring: "border-[#C9D1DB]", text: "text-[#C9D1DB]", bg: "from-[#C9D1DB]/20", h: "h-28 sm:h-36", glow: "" },
  3: { label: "BRONZO", ring: "border-[#CD7F32]", text: "text-[#CD7F32]", bg: "from-[#CD7F32]/20", h: "h-20 sm:h-28", glow: "" },
};
const fmtPct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`);
const fmtUsd = (v) => (v == null ? "" : `${v > 0 ? "+" : ""}${Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: "always" })} $`);

const Step = ({ e, delay }) => {
  const m = MEDALS[e.rank];
  return (
    <div data-testid={`podium-${e.rank}`} className="basis-1/3 max-w-[33.333%] min-w-0 flex flex-col items-center animate-[fadeUp_0.6s_ease-out_both]"
      style={{ animationDelay: `${delay}ms` }}>
      {e.rank === 1 && <Crown size={22} className="text-[#F5C542] mb-1" />}
      <div className={`relative w-16 h-16 sm:w-20 sm:h-20 rounded-full border-4 ${m.ring} ${m.glow} bg-[#0A0A0A] flex items-center justify-center`}>
        <Medal size={30} className={m.text} />
        <span className={`absolute -bottom-2 px-2 rounded-full text-[10px] font-bold bg-[#0A0A0A] border ${m.ring} ${m.text}`}>{e.rank}°</span>
      </div>
      <div className="mt-4 text-center text-white font-semibold text-xs sm:text-sm tracking-wide leading-tight line-clamp-3 break-words [overflow-wrap:anywhere] px-1" title={e.name} data-testid={`podium-${e.rank}-name`}>{e.name}</div>
      <div className={`font-mono font-bold text-base sm:text-xl mt-1 ${e.return_pct >= 0 ? "text-emerald-400" : "text-red-400"}`} data-testid={`podium-${e.rank}-pct`}>{fmtPct(e.return_pct)}</div>
      <div className="font-mono text-[11px] text-zinc-400 h-4">{fmtUsd(e.profit_usd)}</div>
      <div className={`mt-3 w-full ${m.h} rounded-t-lg border-t-2 ${m.ring} bg-gradient-to-b ${m.bg} to-transparent flex items-start justify-center pt-3`}>
        <span className={`text-[10px] sm:text-xs font-bold tracking-[0.2em] ${m.text}`}>{m.label}</span>
      </div>
    </div>
  );
};

export const CupPodium = ({ entries }) => {
  const top = (entries || []).slice(0, 3);
  if (!top.length) return null;
  const order = [top[1], top[0], top[2]].filter(Boolean);
  return (
    <div data-testid="cup-podium" className="flex items-end justify-center gap-2 sm:gap-4 max-w-2xl mx-auto">
      {order.map((e) => <Step key={e.rank} e={e} delay={e.rank === 1 ? 0 : e.rank * 150} />)}
    </div>
  );
};
